import React, { useEffect, useState } from 'react'
import { Col,Row } from 'reactstrap'
import './common.css';
import ActivityStreamTab from '../ViewPipelinesTabs/ActivityStreamTab';

export const ActivitySection = ({task,setScrollBottom,taskId,module, refreshData,allTasksAndSubtasks, viewTaskFunction, selectedActivityFilter,activityFilter, fromDeal, dealName, activityDealData}) => {
	// const [id,setId]=useState();
	// useEffect(e=>{
	// 	setId(taskId);
	// },[taskId]);

	return (
		<Col sm={12}>
			<Row style={{height:"90%"}}>
				<ActivityStreamTab setScrollBottom={setScrollBottom} task={task} pipelineId={taskId} module={module} refreshData={refreshData} allTasksAndSubtasks={allTasksAndSubtasks} 
				viewTaskFunction={viewTaskFunction} selectedActivityFilter={selectedActivityFilter} activityFilter={activityFilter} fromDeal={fromDeal} dealName={dealName} activityDealData = {activityDealData}/>
			</Row>
		</Col>
	)
}
